var Mixin = require('./mixin');
var trackingUtils = require('../utils/tracking.utils');
var EmailCaptureUtils = new Mixin({
    initEmailCapture: function() {
        this.$slctrs = {};
        this.hasLegal = false;
        this.moduleContext = '';
        this.trackKeys = {};
        this.labelConcept = '';
        this.action = '';
    },
    validateEmailCapture: function(e) {
        e.preventDefault();
        var hasLegal = !_.isEmpty(this.$slctrs.legalInput);
        var isLegalChecked = !hasLegal || this.$slctrs.legalInput.is(':checked');

        this.$slctrs.container.removeClass('invalid');
        this.$slctrs.prismaContainer.removeClass('invalid');
        var inputValue = this.$slctrs.input.val();

        if (_.isEmpty(inputValue)) {
            this.setInvalidAndSendTrackingEmailCapture('missing');
        } else if (!Odigeo.Utils.isValidEmail(inputValue)) {
            this.$slctrs.input.val('');
            this.setInvalidAndSendTrackingEmailCapture(isLegalChecked ? 'invalid' : 'both');
        } else if (!isLegalChecked) {
            this.$slctrs.container.removeClass('invalid');
            this.$slctrs.prismaContainer.removeClass('invalid');
            this.$slctrs.legalInput.parent().addClass('error');
            this.setInvalidAndSendTrackingEmailCapture('accept_terms');
        } else {
            this.onSuccess(inputValue);
        }
    },

    showSentMessageEmailCapture: function() {
        this.$slctrs.container.removeClass('invalid').addClass('success');
        this.$slctrs.prismaContainer.removeClass('invalid').addClass('success');
        this.$slctrs.button.removeClass('loading');
        this.trackEventsEmailCapture();
    },

    setInvalidAndSendTrackingEmailCapture: function(errorType) {
        if ('accept_terms' === errorType) {
            this.$slctrs.legalInput.parent().addClass('error');
        } else {
            this.$slctrs.container.addClass('invalid');
            this.$slctrs.prismaContainer.addClass('invalid');
            this.$slctrs.input.attr('placeholder', this.$slctrs.input.data('error-' + ('both' === errorType ? 'invalid' : errorType)));
        }
        this.trackEventsEmailCapture(errorType + '_error');
    },

    trackEventsEmailCapture: function(errorType) {
        var label = this.labelConcept + (errorType || 'successful');
        trackingUtils.trackEvent(
            this.action,
            label,
            this.trackKeys[this.moduleContext]);
    },
});

module.exports = EmailCaptureUtils;
